import { Apis } from "../../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapList = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const popularCommercialInteriorDesign = () => {
  const addPopularCommercialInteriorDesign = async (data) => {
    try {
      const response = await Apis.addPopularCommercialInteriorDesign(data);
      return unwrapResponseBody(response?.data) ?? response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllCommercialInteriorDesigns = async (setCommercialInteriorDesignData) => {
    try {
      const response = await Apis.getAllCommercialInteriorDesigns();
      const items = unwrapList(response?.data);
      setCommercialInteriorDesignData(items);
      return { data: items, ...(unwrapResponseBody(response?.data) || {}) };
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllCommercialInteriorDesignNamesForPopularDesign = async (
    setCommercialInteriorDesignNames,
  ) => {
    try {
      const response = await Apis.getAllCommercialInteriorDesignNamesForPopularDesign();
      const items = unwrapList(response?.data);
      setCommercialInteriorDesignNames(items);
      return { data: items };
    } catch (error) {
      console.error(
        "Error fetching commercial interior design names for popular design:",
        error,
      );
      throw error;
    }
  };

  return {
    addPopularCommercialInteriorDesign,
    getAllCommercialInteriorDesigns,
    getAllCommercialInteriorDesignNamesForPopularDesign,
  };
};
